/*
 * zeroLabs Labor, Adventskalender unter dem Fold (sections/zl-advent-darunter.liquid, zl-advent-darunter.css).
 * Alle fünf Richtungen stehen untereinander, jede lässt sich im Regler ausblenden (html[data-zl-a-darunter] ist die Liste der
 * sichtbaren, gesetzt von zl-produkt-weitere.js). Jede sichtbare Richtung spielt für sich:
 *   tuer: 3D-Szene (zl-a-3d-szenen.js) bis zum Blick ins Fach. Dann steigt aus dem Dunkel die echte Flasche, dieselbe wie auf der
 *         Produktseite der Sorten (zl-flasche.js: Packshot, Etikett aus den Druckdaten), und dreht sich mit dem Scrollen.
 *         Waagerechtes Ziehen dreht sie auch.
 *   auseinander: 3D-Szene.
 *   countdown: rechnet mit dem Datum (im Labor aus dem Regler "Datum", html[data-zl-a-datum]).
 * Der Fortschritt hängt am Scrollen und holt weich auf, auch rückwärts. 3D lädt erst, wenn die Sektion näher als eine
 * Bildschirmhöhe ist. Reduzierte Bewegung: fester Zustand, nichts läuft.
 */
(() => {
  const root = document.querySelector('[data-zl-ad]');
  if (!root) return;
  const html = document.documentElement;
  /* Messpunkte: wie lange ein Teil beim Laden rechnet, sichtbar in der Ladezeit-Prüfung (Lighthouse user-timings) */
  const messen = (name, f) => { const t = performance.now(); try { return f(); } finally { try { performance.measure('zl-ad ' + name, { start: t }); } catch (e) { /* ältere Browser */ } } };
  /* Ohne 3D steht das Standbild der Szene. Bilder mit data-src/data-srcset laden erst jetzt, sonst lädt jeder Besucher sie mit
     (CLAUDE.md, Nur Gezeigtes geht live) */
  const ohne3d = (r) => {
    r.classList.add('ohne-3d');
    r.querySelectorAll('[data-srcset]').forEach((e) => { e.srcset = e.dataset.srcset; e.removeAttribute('data-srcset'); });
    r.querySelectorAll('[data-src]').forEach((e) => { e.src = e.dataset.src; e.removeAttribute('data-src'); });
  };
  const liste = html.dataset.zlADarunter;
  const an = liste == null ? ['tuer', 'auseinander', 'countdown', 'gross', 'sorten', 'oben', 'hand', 'schuetteln'] : liste.split(',').filter(Boolean);
  const grossDreht = html.dataset.zlAGrossArt !== 'oeffnen';
  /* Runde 10: die Seite als Ganzes (Regler "Seite"). A bis D zeigen nur ihre Abschnitte, in ihrer Reihenfolge; "labor" alle zum Vergleich */
  const SEITEN = { A: ['tuer', 'sorten', 'verschenken'], B: ['packzettel'], C: ['oben', 'fuenf'], D: ['brief'] };
  const seite = SEITEN[html.dataset.zlASeite] ? html.dataset.zlASeite : '';
  const zeigen = seite ? SEITEN[seite] : an;
  /* ---------- Was im Karton ist, als Reihe zum Wischen (Labor, html[data-zl-a-karton], Moritz 09.10.2026) ----------
     Die Karte, die einrastet, bekommt .ist-dran und spielt ihren Moment einmal. Antippen spielt ihn noch einmal (Richtung 2: dreht
     die Karte). Pfeile, Punkte, Tastatur, mit der Maus ziehen. Richtung 3 rastet in der Mitte ein, Richtung 4 beginnt mit der
     Uhrzeit, Richtung 5 läuft von selbst weiter, bis jemand wischt oder anhält. */
  const karten = () => {
    const wahl = html.dataset.zlAKarton;
    const box = root.querySelector('[data-zl-ad-karten]');
    if (!wahl || !box) return;
    const reihe = box.querySelector('[data-zl-ad-reihe]');
    const alle = Array.from(reihe.querySelectorAll('.zl-ad__karte'));
    const punkte = box.querySelector('[data-zl-ad-punkte]');
    const pfeile = Array.from(box.querySelectorAll('[data-zl-ad-pfeil]'));
    const name = box.querySelector('[data-zl-ad-fach-name]');
    const mitte = wahl === '3';
    if (!alle.length) return;

    /* Angaben der Sorten aus den Tabellen der Geschichte weiter unten (Dazu, Kalt, Energie): Richtung 2 */
    const zeile = (tabelle, kopf, sorte) => {
      if (!tabelle) return '';
      const spalten = Array.from(tabelle.querySelectorAll('thead th')).map((th) => th.textContent.trim());
      const i = spalten.indexOf(sorte);
      const tr = Array.from(tabelle.querySelectorAll('tbody tr')).find((r) => (r.querySelector('th') || {}).textContent && r.querySelector('th').textContent.trim().indexOf(kopf) === 0);
      if (i < 1 || !tr) return '';
      const td = tr.querySelectorAll('td')[i - 1];
      return td ? td.textContent.replace(/\s+/g, ' ').trim() : '';
    };
    const tabellen = Array.from(document.querySelectorAll('.zl-g__tabelle'));
    const geschmack = tabellen.find((t) => /Dazu/.test(t.textContent));
    const naehr = tabellen.find((t) => /Energie/.test(t.textContent));

    /* Richtung 2: die Rückseite der Sorten (Zutaten mit fetten Allergenen, Dazu, Kalt, Energie) */
    if (wahl === '2') {
      const zutaten = Array.from(document.querySelectorAll('.zl-g__zutaten dl > div'));
      alle.forEach((k) => {
        const hinten = k.querySelector('[data-zl-ad-hinten]');
        if (!hinten || hinten.children.length || k.classList.contains('ist-beigabe')) return;
        const n = k.dataset.name;
        const z = zutaten.find((d) => (d.querySelector('dt') || {}).textContent === n);
        const teile = [
          ['Geschmack', (k.querySelector('.zl-ad__karte-satz') || {}).textContent.replace(' Fünfmal im Karton.', '')],
          ['Dazu', zeile(geschmack, 'Dazu', n)],
          ['Kalt', zeile(geschmack, 'Kalt', n)],
          ['Energie pro 100 ml', zeile(naehr, 'Energie', n)]
        ].filter((x) => x[1]);
        let html2 = '<p class="zl-ad__karte-name"><strong><span></span></strong></p><dl>';
        teile.forEach(([dt]) => { html2 += '<div><dt></dt><dd></dd></div>'; });
        if (z) html2 += '<div><dt>Zutaten</dt><dd data-z></dd></div>';
        hinten.innerHTML = html2 + '</dl>';
        hinten.querySelector('.zl-ad__karte-name span').textContent = n;
        const divs = hinten.querySelectorAll('dl > div');
        teile.forEach(([dt, dd], i) => { divs[i].querySelector('dt').textContent = dt; divs[i].querySelector('dd').textContent = dd; });
        if (z) hinten.querySelector('[data-z]').innerHTML = z.querySelector('dd').innerHTML; /* aus unserer eigenen Seite, mit <strong> für Allergene */
      });
    }

    /* Punkte */
    alle.forEach((k, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'zl-ad__karten-punkt';
      b.setAttribute('aria-label', k.dataset.name);
      b.innerHTML = '<span></span>';
      b.addEventListener('click', () => { anhalten(); gehe(i); });
      punkte.append(b);
    });
    const knoepfe = Array.from(punkte.children);

    /* Welche Karte ist dran: die, deren Kante (3: deren Mitte) am nächsten an der Stelle steht, an der die Reihe einrastet */
    /* Die Kante, an der eine Karte einrastet. Aus dem Innenabstand gelesen: der ist immer in Pixeln aufgelöst, das scroll-padding am Desktop nicht (max() und calc() kommen als Text zurück) */
    const kante = () => { const v = parseFloat(getComputedStyle(reihe).paddingLeft); return isFinite(v) ? v : 0; };
    const naechste = () => {
      const rb = reihe.getBoundingClientRect();
      const stelle = mitte ? rb.left + rb.width / 2 : rb.left + kante();
      let best = 0, d = Infinity;
      alle.forEach((k, i) => {
        const kb = k.getBoundingClientRect();
        const x = mitte ? kb.left + kb.width / 2 : kb.left;
        if (Math.abs(x - stelle) < d) { d = Math.abs(x - stelle); best = i; }
      });
      return best;
    };
    let dran = -1;
    const zeigen = (i) => {
      knoepfe.forEach((b, j) => { b.classList.toggle('ist-dran', j === i); b.toggleAttribute('aria-current', j === i); });
      alle.forEach((k, j) => k.classList.toggle('ist-mitte', j === i));
      if (pfeile[0]) pfeile[0].disabled = i <= 0 && wahl !== '5';
      if (pfeile[1]) pfeile[1].disabled = i >= alle.length - 1 && wahl !== '5';
      if (name) name.textContent = alle[i].dataset.name;
    };
    const einrasten = (i, nochmal) => {
      if (i === dran && !nochmal) return;
      dran = i;
      alle.forEach((k, j) => { if (j !== i) k.classList.remove('ist-dran', 'ist-gedreht'); });
      const k = alle[i];
      k.classList.remove('ist-dran'); void k.offsetWidth; k.classList.add('ist-dran');
      if (wahl === '5') laufen();
      if (wahl === '6') moment(i);
    };
    const gehe = (i, sofort) => {
      const j = (i + alle.length) % alle.length;
      const k = alle[j];
      const rb = reihe.getBoundingClientRect(), kb = k.getBoundingClientRect();
      const ziel = mitte ? reihe.scrollLeft + kb.left + kb.width / 2 - (rb.left + rb.width / 2) : reihe.scrollLeft + kb.left - rb.left - kante();
      if (!isFinite(ziel)) return;
      reihe.scrollTo({ left: Math.max(0, Math.min(ziel, reihe.scrollWidth - reihe.clientWidth)), behavior: sofort || reduziert ? 'auto' : 'smooth' });
    };

    /* ---------- Richtung 6: der Moment jeder Karte ----------
       Film (Unfiltered, Future Pilsner, Futura Hell): fertig geschnitten im Theme, wird erst beim Einrasten geladen und einmal in normaler
       Geschwindigkeit gespielt, danach steht das Endbild. Es spielt immer nur die Karte, die dran ist. 3D (Öffner): das Modell lädt, sobald
       die Karte davor dran ist. Sonst eine CSS-Animation (Klasse ist-dran) mit der Dauer --zl-ad-moment. Der Punkt füllt sich mit. */
    let filmLauf = 0, zeitLauf = 0, drei = null, dreiLaedt = false;
    const tokenZahl = (name, ersatz) => parseFloat(getComputedStyle(box).getPropertyValue(name)) || ersatz;
    const fuellen = (i, p) => { if (i === dran) knoepfe.forEach((b, j) => b.querySelector('span').style.setProperty('--p', j === i ? Math.max(0, Math.min(1, p)).toFixed(3) : '')); };
    const filmZurueck = (k) => {
      const f = k.querySelector('[data-zl-ad-film]');
      if (!f) return;
      const v = f.querySelector('video'), bild = f.querySelector('img');
      if (v) v.pause();
      f.classList.remove('ist-spielt');
      if (bild && bild.dataset.start && bild.getAttribute('src') !== bild.dataset.start) bild.src = bild.dataset.start;
    };
    const dreiLaden = () => {
      const k = alle.find((x) => x.dataset.k === 'oeffner');
      const fl = k && k.querySelector('[data-zl-ad-3d]');
      if (!fl || drei || dreiLaedt || reduziert) return;
      dreiLaedt = true;
      import(fl.dataset.modul).then((m) => m.starten({ flaeche: fl, glb: fl.dataset.glb, hdr: fl.dataset.hdr })).then((d) => {
        drei = d;
        k.classList.add('ist-3d');
        if (alle[dran] === k) moment(dran);
      }).catch(() => { /* ohne WebGL bleibt das Bild des Öffners */ });
    };
    /* Easy Wheat: die Flasche dreht sich eine halbe Umdrehung, zeigt ihren Rücken, hält kurz inne und dreht sanft zurück nach vorn
       (Platzhalter, bis das 3D-Modell der Flasche da ist; Moritz, 09.10.2026: nicht die ganze Drehung wie die Flasche darüber).
       Glas, Licht und Kronkorken kommen aus dem Packshot und bleiben stehen, das Etikett aus den Druckdaten dreht sich
       (assets/zl-flasche.js, wie in der Produktbühne). Die Fläche liegt genau über dem Bild der Flasche, in Ruhe ist sie vom Bild
       nicht zu unterscheiden. */
    let flasche = null, flascheLaedt = false, flascheLauf = 0;
    const HIN = 1500, HALTEN = 900, ZURUECK = 1500; // token-ok: ms, ruhig hin, kurz innehalten, ruhig zurück
    const flascheLegen = () => {
      if (!flasche) return;
      const k = flasche.karte, img = k.querySelector('.zl-ad__karte-flasche'), c = flasche.flaeche;
      const rc = c.getBoundingClientRect(), ri = img.getBoundingClientRect();
      if (!rc.width || !ri.height) return;
      const s = ri.height / 1380; // token-ok: Höhe des Packshots im Bild (zl-g-flasche, 480 x 1380); der Packshot zum Drehen ist 1384 hoch und 2 px tiefer
      flasche.reihe.setze([{ sorte: 'wheat', x: ri.left - rc.left + ri.width / 2, y: ri.top - rc.top - 2 * s, h: 1384 * s }]); // token-ok: wie oben
    };
    const flascheLaden = () => {
      const k = alle.find((x) => x.dataset.k === 'wheat');
      const c = k && k.querySelector('[data-zl-ad-dreh]');
      if (!c || flasche || flascheLaedt || reduziert) return;
      flascheLaedt = true;
      const los = () => {
        if (!window.zlFlasche) return;
        const d = c.dataset;
        const reihe = messen('wheat', () => new window.zlFlasche.Reihe(c, {
          bilder: { wheat: { flasche: d.flasche, maske: d.maske, etikett: d.etikett } },
          hilfen: { profil: d.profil, licht: d.licht, kappe: d.kappe, kappeLicht: d.kappeLicht, etikettAlpha: d.etikettAlpha }
        }));
        if (reihe.ohne) return;
        reihe.lade('wheat').then(() => {
          flasche = { reihe, karte: k, flaeche: c };
          flascheLegen();
          if ('ResizeObserver' in window) new ResizeObserver(flascheLegen).observe(c);
          k.classList.add('ist-dreht');
          if (alle[dran] === k) moment(dran);
        });
      };
      if (window.zlFlasche) { los(); return; }
      const sk = document.createElement('script');
      sk.src = c.dataset.skript; sk.onload = los;
      document.head.append(sk);
    };
    const weich = (x) => { const t = Math.min(1, Math.max(0, x)); return t * t * t * (t * (t * 6 - 15) + 10); }; // token-ok: sanft an, sanft aus
    const flascheDrehen = (i) => {
      cancelAnimationFrame(flascheLauf);
      const r = flasche.reihe, t0 = performance.now(), dauer = HIN + HALTEN + ZURUECK;
      flascheLegen();
      const rund = (t) => {
        const ms = t - t0, x = Math.min(1, ms / dauer);
        const hin = weich(ms / HIN), zurueck = weich((ms - HIN - HALTEN) / ZURUECK);
        r.dreh = Math.PI * (hin - zurueck); // token-ok: eine halbe Umdrehung hin und wieder zurück
        r.zeichne();
        fuellen(i, x);
        if (x < 1 && dran === i) flascheLauf = requestAnimationFrame(rund);
        else { r.dreh = 0; r.zeichne(); }
      };
      flascheLauf = requestAnimationFrame(rund);
    };
    function moment(i) {
      cancelAnimationFrame(filmLauf); cancelAnimationFrame(zeitLauf);
      alle.forEach((k, j) => { if (j !== i) filmZurueck(k); });
      if (i + 1 < alle.length && alle[i + 1].dataset.k === 'oeffner') dreiLaden();
      if (i + 1 < alle.length && alle[i + 1].dataset.k === 'wheat') flascheLaden();
      cancelAnimationFrame(flascheLauf);
      const k = alle[i];
      const f = k.querySelector('[data-zl-ad-film]');
      if (f) {
        const bild = f.querySelector('img');
        if (reduziert) { bild.src = bild.dataset.ende; fuellen(i, 1); return; }
        let v = f.querySelector('video');
        if (!v) {
          v = document.createElement('video');
          v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto'; v.disablePictureInPicture = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
          v.src = f.dataset.quelle;
          f.append(v);
        }
        f.classList.remove('ist-spielt');
        if (bild.getAttribute('src') !== bild.dataset.start) bild.src = bild.dataset.start;
        fuellen(i, 0);
        const endbild = () => { v.pause(); bild.src = bild.dataset.ende; f.classList.remove('ist-spielt'); fuellen(i, 1); };
        const tick = () => {
          if (dran !== i) return;
          if (v.duration) fuellen(i, v.currentTime / v.duration);
          if (v.ended) { endbild(); return; }
          filmLauf = requestAnimationFrame(tick);
        };
        v.onplaying = () => { if (dran === i) f.classList.add('ist-spielt'); };
        v.onended = () => { if (dran === i) endbild(); };
        v.onerror = () => endbild();
        try { v.currentTime = 0; } catch (e) { /* noch nicht geladen, startet ohnehin vorn */ }
        const p = v.play();
        if (p && p.catch) p.catch(() => endbild());
        filmLauf = requestAnimationFrame(tick);
        return;
      }
      if (k.dataset.k === 'oeffner' && drei) {
        if (reduziert) { drei.ende(); fuellen(i, 1); return; }
        drei.spielen((p) => fuellen(i, p));
        return;
      }
      if (k.dataset.k === 'oeffner') dreiLaden();
      if (k.dataset.k === 'wheat') {
        if (flasche && !reduziert) { flascheDrehen(i); return; }
        flascheLaden();
        fuellen(i, 1);
        return;
      }
      /* CSS-Moment: nur der Punkt läuft mit */
      if (reduziert) { fuellen(i, 1); return; }
      const dauer = tokenZahl('--zl-ad-moment-' + k.dataset.k, tokenZahl('--zl-ad-moment', 1600)), t0 = performance.now(); // token-ok: Ersatz, falls der Token fehlt
      const zeit = (t) => { const p = (t - t0) / dauer; fuellen(i, p); if (p < 1 && dran === i) zeitLauf = requestAnimationFrame(zeit); };
      zeitLauf = requestAnimationFrame(zeit);
    }

    let ruhe = 0;
    reihe.addEventListener('scroll', () => {
      const i = naechste();
      zeigen(i);
      clearTimeout(ruhe);
      ruhe = setTimeout(() => einrasten(naechste()), 140); // token-ok: kurz nach dem Stehenbleiben, wenn die Karte eingerastet ist
    }, { passive: true });

    pfeile.forEach((b) => b.addEventListener('click', () => { anhalten(); gehe(naechste() + parseInt(b.dataset.zlAdPfeil, 10)); }));
    reihe.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); anhalten(); gehe(naechste() + (e.key === 'ArrowRight' ? 1 : -1)); }
    });

    /* Mit der Maus ziehen (am Finger wischt der Browser selbst). Wer mehr als ein paar Pixel zieht, hat nicht getippt.
       Beim Loslassen geht es mit dem Schwung weiter: schnell gezogen eine Karte weiter, langsam zur nächsten. */
    reihe.querySelectorAll('img').forEach((im) => { im.draggable = false; });
    reihe.addEventListener('dragstart', (e) => e.preventDefault());
    let zug = null, gezogen = false;
    reihe.addEventListener('pointerdown', (e) => {
      gezogen = false;
      if (e.pointerType !== 'mouse' || e.button > 0) return;
      if (e.target.closest('button, a')) return;
      zug = { x: e.clientX, links: reihe.scrollLeft, id: e.pointerId, t: performance.now(), v: 0, lx: e.clientX, start: naechste() };
      e.preventDefault();
    });
    window.addEventListener('pointermove', (e) => {
      if (!zug || e.pointerId !== zug.id) return;
      const dx = e.clientX - zug.x;
      if (!gezogen && Math.abs(dx) > 6) { // token-ok: ab hier ist es Ziehen
        gezogen = true; anhalten();
        reihe.classList.add('ist-gezogen');
        try { reihe.setPointerCapture(zug.id); } catch (f) { /* ohne Capture geht es über window weiter */ }
      }
      if (!gezogen) return;
      const t = performance.now(), dt = Math.max(1, t - zug.t);
      zug.v = (e.clientX - zug.lx) / dt; zug.t = t; zug.lx = e.clientX;
      reihe.scrollLeft = zug.links - dx;
    });
    const loslassen = (e) => {
      if (!zug || (e && e.pointerId !== zug.id)) return;
      const z = zug; zug = null;
      if (!gezogen) return;
      let i = naechste();
      const schwung = Math.abs(z.v) > 0.3; // token-ok: Pixel pro Millisekunde, ab hier ein Wurf
      if (i === z.start && (schwung || Math.abs(z.lx - z.x) > 40)) i += z.lx < z.x ? 1 : -1; // token-ok: ein kurzer Zug reicht für die nächste Karte
      gehe(Math.max(0, Math.min(alle.length - 1, i)));
      /* Einrasten erst wieder an, wenn die Reihe steht, sonst reißt der Browser sie mitten im Gleiten an die nächste Kante */
      let aus = 0;
      const fertig = () => { reihe.removeEventListener('scroll', warten); reihe.classList.remove('ist-gezogen'); };
      const warten = () => { clearTimeout(aus); aus = setTimeout(fertig, 160); }; // token-ok: so lange ohne Bewegung heißt: steht
      reihe.addEventListener('scroll', warten, { passive: true });
      warten();
      /* Den Klick nach dem Ziehen schlucken, sonst springt die Karte zurück */
      const schlucken = (c) => { c.stopPropagation(); c.preventDefault(); };
      window.addEventListener('click', schlucken, { capture: true, once: true });
      setTimeout(() => window.removeEventListener('click', schlucken, { capture: true }), 0);
      setTimeout(() => { gezogen = false; }, 0);
    };
    window.addEventListener('pointerup', loslassen);
    window.addEventListener('pointercancel', loslassen);
    reihe.addEventListener('touchstart', () => anhalten(), { passive: true });

    /* Antippen: der Moment noch einmal, in Richtung 2 dreht sich die Karte, in Richtung 3 und 4 holt es die Karte in die Mitte.
       Richtung 6: Antippen der Karte, die dran ist, spielt nichts; der Moment kommt wieder, wenn man hinblättert (Wischen, Pfeile, Punkte). */
    alle.forEach((k, i) => {
      const drehen = () => { k.classList.toggle('ist-gedreht'); };
      const knopf = k.querySelector('.zl-ad__karte-drehen');
      if (knopf) knopf.addEventListener('click', (e) => { e.stopPropagation(); drehen(); });
      k.addEventListener('click', () => {
        if (gezogen) return;
        if (i !== naechste()) { anhalten(); gehe(i); return; }
        if (wahl === '2') drehen();
        else if (wahl !== '6') einrasten(i, true);
      });
    });

    /* Richtung 5: läuft von selbst weiter, solange die Reihe im Bild ist und niemand eingreift */
    let auto = wahl === '5' && !reduziert, sichtbar = false, start = 0, lauf = 0;
    let seiteZeit = 0;
    window.addEventListener('scroll', () => { seiteZeit = performance.now(); }, { passive: true });
    const pause = box.querySelector('[data-zl-ad-pause]');
    const balken = (p) => knoepfe.forEach((b, j) => b.querySelector('span').style.setProperty('--p', j === dran ? p.toFixed(3) : ''));
    const takt = () => parseFloat(getComputedStyle(box).getPropertyValue('--zl-ad-spot')) || 4000; // token-ok: Ersatz, falls der Token fehlt
    function laufen() {
      cancelAnimationFrame(lauf);
      if (!auto || !sichtbar) { balken(1); return; }
      start = performance.now();
      const schritt = (t) => {
        const p = Math.min(1, (t - start) / takt());
        balken(p);
        /* Nie weiterblättern, während jemand die Seite scrollt: am iPhone würde das Wischen der Seite sonst abgebrochen */
        if (p >= 1 && t - seiteZeit > 900) { gehe(dran + 1); return; } // token-ok: erst, wenn die Seite kurz stillsteht
        lauf = requestAnimationFrame(schritt);
      };
      lauf = requestAnimationFrame(schritt);
    }
    function anhalten() {
      if (!auto) return;
      auto = false;
      box.classList.add('ist-angehalten');
      cancelAnimationFrame(lauf);
      balken(1);
      if (pause) pause.setAttribute('aria-label', 'Abspielen');
    }
    if (pause) pause.addEventListener('click', () => {
      if (auto) { anhalten(); return; }
      auto = true; box.classList.remove('ist-angehalten'); pause.setAttribute('aria-label', 'Anhalten'); laufen();
    });
    if (wahl === '5' && 'IntersectionObserver' in window) {
      new IntersectionObserver((e) => {
        sichtbar = e.some((x) => x.isIntersecting);
        if (sichtbar) laufen(); else cancelAnimationFrame(lauf);
      }, { threshold: 0.5 }).observe(reihe); // token-ok: zur Hälfte im Bild
    }

    /* Richtung 4: die Reihe beginnt mit der Karte, die zur Uhrzeit passt */
    let anfang = 0;
    if (wahl === '4') {
      const h = new Date().getHours();
      const sorte = h >= 5 && h < 11 ? 'wheat' : h < 15 ? 'pils' : h < 18 ? 'lemon' : h < 21 ? 'hell' : 'unfiltered'; // token-ok: Uhrzeiten des Tages
      anfang = Math.max(0, alle.findIndex((k) => k.dataset.k === sorte));
    }
    requestAnimationFrame(() => {
      if (anfang) gehe(anfang, true);
      zeigen(anfang);
      /* Der erste Moment spielt erst, wenn die Reihe ins Bild kommt */
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((e) => {
          if (e.some((x) => x.isIntersecting)) { io.disconnect(); einrasten(naechste()); }
        }, { threshold: 0.6 }); // token-ok: gut zur Hälfte im Bild
        io.observe(reihe);
      } else einrasten(anfang);
    });
  };
  root.querySelectorAll('[data-r]').forEach((r) => { r.hidden = !zeigen.includes(r.dataset.r); });
  if (seite) {
    const daten = root.querySelector('script[data-zl-o-flaschen]');
    SEITEN[seite].forEach((k) => { const r = root.querySelector('[data-r="' + k + '"]'); if (r) root.appendChild(r); });
    if (daten) root.appendChild(daten);
    /* Die Sorten enden mit Plus, Öffner und Gutschein (Moritz 07.10.2026: die gehören dazu, auch wenn sie im Fold stehen) */
  }
  const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const webgl = (() => { try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (e) { return false; } })();

  /* Kopf: dieselbe Höhe wie die Bühne oben, zl-produkt-weitere.js misst den festen Kopf und setzt --b-kopf */
  let kopf = 0;
  const kopfMessen = () => {
    const b = document.querySelector('[data-zl-o]');
    const h = b ? parseFloat(getComputedStyle(b).getPropertyValue('--b-kopf')) : 0;
    kopf = Math.max(0, Math.round(h || 0));
    root.style.setProperty('--ad-kopf', kopf + 'px'); // token-ok: gemessen
  };
  kopfMessen();

  /* Was erst weiter unten gebraucht wird (Szenen in 3D, die echten Flaschen), startet erst, wenn der erste Bildschirm ruhig ist, und
     dann eine Bildschirmhöhe vorher. Gemessen am 15.10.2026: Die Flasche von Türchen 7 rechnete sonst schon beim Laden, gedrosselt
     0,5 bis 1,4 s, und nahm dem ersten Bildschirm die Zeit. Gemessen am 28.10.2026: Türchen 7 baute sein Modell mitten im Auftritt
     des Kalenders, der Auftritt stockte.
     Ruhig heißt: Der Auftritt des Kalenders ist zu Ende, oder das Endbild steht (Ereignis zl:a-ruhig aus zl-a-3d-drehen.js,
     zl-a-netz.liquid, zl-produkt-weitere.js), danach im Leerlauf. Scrollt der Besucher, startet sofort, was er gleich sieht. Das Ende
     des Ladens der Seite zählt nicht: Es kommt, bevor das Modell oben da ist. Ohne Kalender in 3D oben gilt wie bisher das Laden. */
  const foldWartet = html.dataset.zlAFold === 'drehen' && !!document.querySelector('[data-zl-a-drei]');
  let ersterSteht = !foldWartet && document.readyState === 'complete';
  const wartend = [];
  const ersterDa = () => { if (ersterSteht) return; ersterSteht = true; performance.mark('zl-ad-darunter-start'); wartend.splice(0).forEach((g) => g()); };
  const leerlauf = (f) => { if ('requestIdleCallback' in window) requestIdleCallback(f, { timeout: 1000 }); else setTimeout(f, 200); }; // token-ok: höchstens 1 s auf Leerlauf warten
  if (!ersterSteht) {
    window.addEventListener('scroll', ersterDa, { once: true, passive: true });
    if (foldWartet) {
      document.addEventListener('zl:a-ruhig', () => leerlauf(ersterDa), { once: true });
      setTimeout(ersterDa, 15000); // token-ok: Sicherung, falls oben nichts meldet; der Wächter oben zeigt das Endbild nach 12 s
    } else {
      window.addEventListener('load', ersterDa, { once: true });
      /* Der erste Bildschirm des Kalenders meldet, wenn das Modell oder das Standbild steht (zl-produkt-weitere.js, zl-a-netz.liquid) */
      document.addEventListener('zl:a-erster', ersterDa, { once: true });
    }
  }
  const bald = (el, f) => {
    if (!('IntersectionObserver' in window)) { f(); return; }
    const beobachten = () => {
      const io = new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); f(); } }, { rootMargin: '100% 0px' }); // token-ok: eine Bildschirmhöhe vorher laden
      io.observe(el);
    };
    if (ersterSteht) beobachten(); else wartend.push(beobachten);
  };
  const klemm = (x) => Math.min(1, Math.max(0, x));
  const glatt = (x) => { x = klemm(x); return x * x * (3 - 2 * x); };

  /* Die echten Flaschen (zl-flasche.js), dieselben wie auf der Produktseite der Sorten: Packshot, Etikett aus den Druckdaten */
  const SORTEN = ['unfiltered', 'pils', 'hell', 'wheat', 'lemon'];
  const RATIO = 480 / 1384; // token-ok: Seitenverhältnis der Packshots
  const flaschenDaten = () => { try { return JSON.parse(document.querySelector('[data-zl-o-flaschen]').textContent); } catch (e) { return null; } };
  const neueReihe = (cv, griff) => {
    const W = flaschenDaten();
    if (!W || !window.zlFlasche || !cv) return null;
    const r = messen('flasche', () => new window.zlFlasche.Reihe(cv, { bilder: W.bilder, hilfen: W.hilfen, griff }));
    return r.ohne ? null : r;
  };

  /* ---------- Datum: welcher Tag im Dezember (0 davor, 32 danach), wie viele Tage bis zum ersten ---------- */
  const datum = () => {
    const heute = (() => {
      const d = html.dataset.zlADatum;
      if (d && d !== 'heute') { const [y, m, t] = d.split('-').map(Number); return new Date(y, m - 1, t); }
      const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate());
    })();
    const jahr = heute.getMonth() === 0 ? heute.getFullYear() - 1 : heute.getFullYear();
    const erster = new Date(jahr, 11, 1);
    const tag = heute.getMonth() === 11 ? heute.getDate() : (heute < erster ? 0 : 32);
    const tage = Math.round((erster - heute) / 86400000); // token-ok: Millisekunden je Tag
    return { tag, tage };
  };

  /* ---------- Countdown ---------- */
  const countdown = (r) => {
    const { tag, tage } = datum();
    const gross = r.querySelector('[data-zl-ad-gross]'), hinweis = r.querySelector('[data-zl-ad-hinweis]');
    if (tag === 0) gross.textContent = tage === 1 ? 'Morgen.' : 'Noch ' + tage + ' Tage.';
    else if (tag <= 24) gross.textContent = 'Heute Türchen ' + tag + '.';
    else gross.textContent = 'Alle offen.';
    let ruhe = 0;
    r.querySelectorAll('[data-tag]').forEach((b) => {
      const d = parseInt(b.dataset.tag, 10);
      const offen = d <= tag;
      b.classList.toggle('ist-offen', offen);
      if (offen) b.setAttribute('aria-label', (d === 25 ? 'Türchen mit Logo' : 'Türchen ' + d) + ', offen');
      b.addEventListener('click', () => {
        if (b.classList.contains('ist-offen')) { hinweis.textContent = 'Schon offen.'; return; }
        b.classList.remove('wackelt'); void b.offsetWidth; b.classList.add('wackelt');
        hinweis.textContent = d === 25 ? 'Noch nicht.' : 'Noch nicht. Am ' + d + '. Dezember.';
        clearTimeout(ruhe); ruhe = setTimeout(() => { hinweis.textContent = ''; }, 2600); // token-ok: so lange steht der Hinweis
      });
      b.addEventListener('animationend', () => b.classList.remove('wackelt'));
    });
  };

  /* ---------- Richtungen mit Fortschritt am Scrollen ---------- */
  const teile = [];
  const machen = (r) => {
    const wahl = r.dataset.r;
    const buehne = r.querySelector('.zl-ad__buehne');
    const lauf = r.querySelector('[data-zl-ad-lauf]');
    const fl = r.querySelector('[data-fl]');
    const t = { r, wahl, ist: 0, soll: 0, szene: null, flasche: null, fl };
    t.ziel = () => {
      if (reduziert) return wahl === 'tuer' || wahl === 'steigt' ? 1 : wahl === 'auseinander' ? 0.82 : wahl === 'sorten' ? 0.11 : wahl === 'hand' ? 0.5 : 1; // token-ok: der aussagekräftigste Zustand
      if (buehne) {
        const b = r.getBoundingClientRect();
        return klemm((kopf - b.top) / Math.max(1, r.offsetHeight - buehne.offsetHeight));
      }
      if (lauf) {
        const b = lauf.getBoundingClientRect(), vh = window.innerHeight;
        return klemm((vh * 0.9 - b.top) / Math.max(1, b.height + vh * 0.25)); // token-ok: beginnt, wenn der Monat ins Bild kommt, fertig, bevor er oben ist
      }
      return 0;
    };
    t.zeichnen = () => {
      r.style.setProperty('--ad-p', t.ist.toFixed(4));
      /* Türchen sieben: das 3D endet im Fach. Groß gesagt: die Türchen gehen erst auf, wenn die Sätze gegangen sind */
      const p3 = wahl === 'tuer' ? Math.min(0.7, t.ist * 0.68 / 0.48) : (wahl === 'gross' && !grossDreht) ? klemm((t.ist - 0.84) / 0.16) : t.ist; // token-ok: Abschnitte des Wegs
      if (t.szene) t.szene.zeichnen(p3, Math.round(t.fl.clientWidth), Math.round(t.fl.clientHeight));
      if (t.flasche) t.flasche();
    };
    if (['tuer', 'auseinander', 'gross', 'oben', 'hand', 'schuetteln', 'steigt'].includes(wahl) && fl) {
      if (!webgl) ohne3d(r);
      else {
        /* Jede 3D-Szene lebt nur, solange sie näher als gut eine Bildschirmhöhe ist. Weiter weg wird sie aufgeräumt und die Fläche
           durch eine frische ersetzt (eine verlorene WebGL-Fläche lässt sich nicht wieder beleben). Sonst sammeln sich am iPhone
           sieben Modelle und sieben WebGL-Flächen, und Safari beendet die Seite. */
        let nah = false, laedt = false;
        const erzeugen = () => {
          laedt = true;
          const daten = { flaeche: t.fl, teile: root.dataset.teile, glb: root.dataset.glb, hdr: root.dataset.hdr, schatten: root.dataset.schatten, inhalt: [0.12, 0.3, 0.88, 0.82] }; // token-ok: Groß gesagt: der Karton mittig, Luft für die Sätze
          if (wahl === 'auseinander') {
            const W = flaschenDaten();
            if (W && W.bilder) { daten.etiketten = {}; SORTEN.forEach((k) => { if (W.bilder[k]) daten.etiketten[k] = W.bilder[k].etikett; }); }
            daten.etikettMaske = root.dataset.etikettMaske;
          }
          if (wahl === 'tuer') daten.kronkorken = root.dataset.kronkorken;
          if (wahl === 'oben') { daten.tag = datum().tag; daten.tippen = (n, offen) => obenTipp(r, n, offen); }
          if (wahl === 'steigt') {
            const W = flaschenDaten();
            if (W && W.bilder && W.bilder.unfiltered) daten.etikett = W.bilder.unfiltered.etikett;
            daten.etikettMaske = root.dataset.etikettMaske;
            /* wie der Fold endet: nur drei Türchen offen (Regler "Im Fold", Standard) oder alle */
            if (html.dataset.zlAFold !== 'alle') daten.offen = [13, 19, 22];
          }
          const szene = wahl === 'gross' ? (grossDreht ? 'runde' : null) : wahl;
          (szene ? import(root.dataset.szenen).then((m) => m[szene](daten)) : import(root.dataset.drei).then((m) => m.starten(daten)))
            .then((sz) => { laedt = false; t.szene = sz; if (!nah) wegraeumen(); else t.zeichnen(); })
            .catch(() => { laedt = false; ohne3d(r); });
        };
        const wegraeumen = () => {
          if (!t.szene) return;
          if (t.szene.weg) t.szene.weg();
          t.szene = null;
          const frisch = t.fl.cloneNode(false);
          t.fl.replaceWith(frisch); t.fl = frisch;
        };
        /* Die Szene startet erst, wenn der erste Bildschirm steht (Modell oder Standbild da, Seite geladen) oder der Besucher scrollt.
           Gemessen am 15.10.2026: Türchen 7 beginnt am Handy gleich unter dem ersten Bildschirm und lud sonst schon beim Aufruf
           Modell, Licht und Kronkorken, auch wenn oben bei langsamem Netz das Standbild stand, und nahm ihm die Leitung. */
        if ('IntersectionObserver' in window) {
          const beobachten = () => new IntersectionObserver((e) => {
            nah = e.some((x) => x.isIntersecting);
            if (nah && !t.szene && !laedt) erzeugen();
            else if (!nah && !laedt) wegraeumen();
          }, { rootMargin: '120% 0px' }).observe(r); // token-ok: gut eine Bildschirmhöhe vorher laden, danach aufräumen
          if (ersterSteht) beobachten(); else wartend.push(beobachten);
        } else { nah = true; erzeugen(); }
        if (wahl === 'tuer') bald(r, () => echteFlasche(r, t));
        if (wahl === 'steigt') bald(r, () => steigtFlasche(r, t));
      }
    }

    if (wahl === 'oben') obenText(r);
    if (wahl === 'sorten') bald(r, () => sortenFlasche(r, t));
    t.ist = t.soll = t.ziel();
    t.zeichnen();
    teile.push(t);
  };

  /* Türchen sieben: die echte Flasche steigt aus dem Dunkel. Sie taucht dort auf, wo das Fach war, und kommt ein Stück herauf,
     erst schnell, dann immer langsamer, bis sie ruhig steht (Kurve, die ausläuft, kein Anfahren). Dabei wird sie aus dem Schwarz
     hell. Die Drehung ist von dem Steigen getrennt: eine ganze Drehung über den ganzen restlichen Weg, sanft an beiden Enden, am Ende
     steht das Etikett vorn. Ziehen dreht sie zusätzlich. (Moritz, 06.10.2026: kam zu schnell, wirkte nicht smooth.) */
  const echteFlasche = (r, t) => {
    const cv = r.querySelector('[data-zl-ad-flasche]');
    const reihe = neueReihe(cv, cv);
    if (!reihe) return;
    const sorte = cv.dataset.sorte || 'unfiltered';
    let basis = 0;
    reihe.lade([sorte]).then(() => t.zeichnen());
    t.flasche = () => {
      const steigt = klemm((t.ist - 0.48) / 0.4); // token-ok: vom Schwarz im Fach bis kurz vor dem Satz
      const e = 1 - Math.pow(1 - steigt, 3); // token-ok: läuft weich aus
      r.classList.toggle('ist-flasche', t.ist > 0.47);
      cv.style.filter = steigt < 1 ? 'brightness(' + Math.min(1, steigt * 2.5).toFixed(3) + ')' : ''; // token-ok: aus dem Dunkel hell werden
      const B = cv.clientWidth, H = cv.clientHeight;
      if (!B || !H) return;
      const h = Math.min(H * 0.66, B / RATIO * 0.62); // token-ok: Format der Packshots, Flasche zwei Drittel hoch
      const yEnde = H * 0.84 - h, yStart = yEnde + h * 0.45; // token-ok: der Fuß steht frei über der Leiste mit dem Button, steigt knapp eine halbe Flaschenhöhe
      const y = yStart + (yEnde - yStart) * e;
      const dreh = Math.PI * 2 * glatt((t.ist - 0.48) / 0.38); // token-ok: die Drehung endet, bevor der Satz kommt, mit dem Etikett vorn // token-ok: eine Drehung bis zum Ende des Wegs
      reihe.dreh += dreh - basis; basis = dreh;
      reihe.setze([{ sorte, x: B / 2, y, h, dreh: 0 }]);
    };
  };

  /* C: ein angetipptes Türchen sagt, wann es dran ist */
  let tippRuhe = 0;
  const obenTipp = (r, n, offen) => {
    const el = r.querySelector('[data-zl-ad-tipp]');
    if (!el) return;
    el.textContent = offen ? 'Schon offen.' : 'Noch nicht. Am ' + n + '. Dezember.';
    clearTimeout(tippRuhe); tippRuhe = setTimeout(() => { el.textContent = ''; }, 2600); // token-ok: so lange steht der Hinweis
  };

  /* A Eine steigt: ab der Mitte des Wegs steht die echte Unfiltered an der Stelle der Flasche aus dem Modell und steigt das letzte Stück */
  const steigtFlasche = (r, t) => {
    const cv = r.querySelector('[data-zl-ad-steigt]');
    const reihe = neueReihe(cv, cv);
    if (!reihe) return;
    reihe.lade(['unfiltered']).then(() => t.zeichnen());
    let basis = 0;
    t.flasche = () => {
      const da = klemm((t.ist - 0.5) / 0.12); // token-ok: blendet über, wenn die Kamera auf Augenhöhe ist
      cv.style.opacity = da.toFixed(3);
      const B = cv.clientWidth, H = cv.clientHeight;
      if (!B || !H) return;
      const h = Math.min(H * 0.62, B / RATIO * 0.5); // token-ok: Flasche knapp zwei Drittel hoch
      const e = 1 - Math.pow(1 - klemm((t.ist - 0.5) / 0.4), 3); // token-ok: läuft weich aus
      const y = H * 0.9 - h - h * 0.12 * e; // token-ok: über der Leiste mit dem Button, steigt noch ein Stück
      const dreh = Math.PI * 2 * glatt((t.ist - 0.5) / 0.5);
      reihe.dreh += dreh - basis; basis = dreh;
      reihe.setze([{ sorte: 'unfiltered', x: B / 2, y, h, dreh: 0 }]);
    };
  };

  /* A Ausklang: der Satz zum Datum */
  const ausklang = (r) => {
    const el = r.querySelector('[data-zl-ad-noch]');
    if (!el) return;
    const { tag, tage } = datum();
    if (tag === 0) el.textContent = tage === 1 ? 'Morgen ist das erste Türchen dran.' : 'Noch ' + tage + ' Tage bis zum ersten Türchen.';
    else if (tag <= 25) el.textContent = 'Heute ist Türchen ' + tag + ' dran.';
    else el.textContent = 'Bis zum nächsten Dezember.';
  };

  /* B Der Packzettel: Antippen öffnet die Zeile, die echte Flasche dreht sich darin einmal */
  const packzettel = (r) => {
    r.querySelectorAll('[data-zl-ad-zeile]').forEach((z) => {
      let reihe = null, lauf = 0;
      z.addEventListener('toggle', () => {
        if (!z.open) return;
        const cv = z.querySelector('canvas');
        if (!reihe) { reihe = neueReihe(cv, cv); if (!reihe) return; }
        const sorte = z.dataset.sorte;
        reihe.lade([sorte]).then(() => {
          const B = cv.clientWidth, H = cv.clientHeight;
          const h = H * 0.92, start = performance.now(); // token-ok: die Flasche füllt die Zeile
          let basis = 0;
          cancelAnimationFrame(lauf);
          const schritt = (jetzt) => {
            const p = reduziert ? 1 : klemm((jetzt - start) / 1200); // token-ok: eine Drehung in 1,2 s
            const dreh = Math.PI * 2 * glatt(p);
            reihe.dreh += dreh - basis; basis = dreh;
            reihe.setze([{ sorte, x: B / 2, y: (H - h) / 2, h, dreh: 0 }]);
            if (p < 1) lauf = requestAnimationFrame(schritt);
          };
          lauf = requestAnimationFrame(schritt);
        });
      });
    });
  };

  /* 9 Von oben: der Satz unter dem Deckel kennt das Datum */
  const obenText = (r) => {
    const el = r.querySelector('[data-zl-ad-oben]');
    if (!el) return;
    const { tag, tage } = datum();
    if (tag === 0) el.textContent = tage === 1 ? 'Morgen geht das erste auf.' : 'Noch ' + tage + ' Tage bis zum ersten.';
    else if (tag <= 25) el.textContent = 'Heute ist Türchen ' + tag + ' dran.';
    else el.textContent = 'Alle offen.';
  };

  /* 7 Eine nach der anderen: eine Flasche in der Mitte. Eine ganze Drehung je Sorte, bei der halben (Etikett hinten) wird sie zur
     nächsten. Nach Lemon Infused bleibt sie stehen und blendet aus, es folgen das Plus, der Öffner und der Gutschein (CSS). */
  const sortenFlasche = (r, t) => {
    /* Fassung c (Labor): Wischen statt Scrollen, keine Flasche in WebGL */
    if (html.dataset.zlAKurz === 'c' || html.dataset.zlAKarton) return;
    const cv = r.querySelector('[data-zl-ad-sorten]');
    const reihe = neueReihe(cv, cv);
    if (!reihe) return;
    let basis = 0;
    /* Wie viele Sätze vor den Sorten stehen: der erste und "Fünfmal", das wegfällt, wenn "5×" im Marker steht (Labor). Die Bühne wird
       je Satz eine Stelle länger (CSS --ad-vor). Bei jedem Bild gelesen, weil das Labor seine Stellung auch später setzen kann. */
    const satzVorab = r.querySelector('.zl-ad__einleitung--vorab'), satzFuenf = r.querySelector('.zl-ad__einleitung--fuenf');
    const vorZaehlen = () => (satzVorab ? 1 : 0) + (satzFuenf && html.dataset.zlAFuenf !== 'marker' ? 1 : 0);
    reihe.lade(SORTEN).then(() => t.zeichnen());
    t.flasche = () => {
      /* Acht Stellen: fünf Sorten, das Plus, Öffner, Gutschein. Sieben Wechsel auf gut sieben Achteln des Wegs, der Rest bleibt stehen. */
      /* Fassungen a und b (Labor, Moritz 09.10.2026): Öffner und Gutschein sind zusammen eine Stelle, die Sätze stehen nur ein Drittel
         ihres Wegs still */
      const kurz = html.dataset.zlAKurz === 'a' || html.dataset.zlAKurz === 'b';
      const reihe5 = html.dataset.zlAKurz === 'b';
      const max = 'ohneBeigaben' in r.dataset ? 4 : kurz ? 5 : 7; // token-ok: vier Wechsel ohne Beigaben, fünf mit beiden zusammen, sieben mit Plus, Öffner und Gutschein einzeln
      /* Vorher stehen die Sätze, was im Karton ist (Stellen -2 und -1, oder nur -1): jeder geht nach links, von rechts kommt der nächste,
         nach dem letzten die erste Sorte */
      const vor = vorZaehlen();
      if (r.style.getPropertyValue('--ad-vor') !== String(vor)) r.style.setProperty('--ad-vor', String(vor));
      const roh = Math.min(1, t.ist * (max === 4 ? 1.25 : 1.14)) * (max + vor) - vor; // token-ok: gut eine Bildschirmhöhe je Stelle, eine mehr je Satz
      const halt = kurz ? 1 / 3 : 0.5; // token-ok: so lange steht jeder Satz still in der Mitte
      const alles = roh < 0 ? Math.floor(roh) + Math.max(0, roh - Math.floor(roh) - halt) / (1 - halt) : roh; // token-ok: danach geht er
      r.style.setProperty('--ad-s', alles.toFixed(4));
      const st = Math.max(0, Math.min(4, alles));
      const B = cv.clientWidth, H = cv.clientHeight;
      if (!B || !H) return;
      /* Steht der Name über oder unter der Flasche (Regler, html[data-zl-a-marker]), wird sie kleiner und rückt zur anderen Seite */
      const lage = html.dataset.zlAMarker;
      const neben = lage === 'oben' || lage === 'unten';
      const h = Math.min(H * (neben ? 0.56 : 0.7), B * 0.5 / RATIO); // token-ok: groß in der Mitte, nie breiter als die halbe Bühne
      const y = lage === 'oben' ? H * 0.84 - h : lage === 'unten' ? H * 0.1 : (H - h) / 2 + H * 0.04; // token-ok: Lage der Flasche je nach Name, unten bleibt Platz für die Leiste mit dem Button
      if (reihe5) {
        /* b: alle fünf in einer Reihe, auf einer Grundlinie. Die Sorte, die dran ist, tritt vor (größer, etwas tiefer) und dreht sich
           einmal, während sie an die nächste übergibt. Gezeichnet wird von hinten nach vorn. */
        const abstand = Math.min(B / 5.4, H * 0.2); // token-ok: fünf Flaschen mit Luft, am Desktop nicht zu weit auseinander
        const h0 = Math.min(H * 0.4, abstand * 0.9 / RATIO); // token-ok: so hoch, dass sie sich in der Reihe nicht berühren
        const grund = H * 0.8; // token-ok: Grundlinie, unten bleibt Platz für die Leiste mit dem Button
        const slots = SORTEN.map((sorte, i) => {
          const nah = Math.max(0, 1 - Math.abs(st - i));
          const hi = h0 * (1 + 0.38 * nah); // token-ok: tritt ein gutes Drittel größer vor
          return { sorte, x: B / 2 + (i - 2) * abstand, y: grund + H * 0.03 * nah - hi, h: hi, dreh: Math.PI * 2 * Math.max(0, Math.min(1, st - i)), nah }; // token-ok: eine Drehung beim Übergeben
        }).sort((p, q) => p.nah - q.nah);
        reihe.setze(slots);
        return;
      }
      const dreh = Math.PI * 2 * st;
      reihe.dreh += dreh - basis; basis = dreh;
      reihe.setze([{ sorte: SORTEN[Math.min(4, Math.round(st))], x: B / 2, y, h, dreh: 0 }]);
    };
    t.zeichnen();
  };

  /* Erzählung (Moritz, 07.10.2026): nach der Kalender-Magie zuerst Max und Moritz, warum es den Kalender gibt, dann die Biere im Detail.
     Das Kapitel steht in der Geschichte der Produktseite B weiter unten, hier rückt es vor "Was reinkommt". */
  /* Ohne das Kapitel "Was reinkommt" (Zutaten unter den Nährwerten, Moritz 08.10.2026) ist das erste Kapitel des Wegs der Anker */
  const wer = document.querySelector('.zl-g--weg .zl-g__kapitel--wer'), rein = document.querySelector('.zl-g--weg .zl-g__kapitel--rein') || document.querySelector('.zl-g--weg .zl-g__kapitel--ort');
  if (wer && rein && rein.parentElement === wer.parentElement) rein.before(wer);
  /* Runde 13 (Moritz, 08.10.2026): danach zuerst, was andere sagen (Bewertung, Auszeichnungen, Presse) und "Schmeckt das wirklich?",
     erst dann der Weg ins Glas. Die Stimmen sind eine eigene Sektion, sie wandert hinter das Kapitel. */
  const andere = document.querySelector('.zl-g--weg .zl-g__kapitel--andere');
  if (andere && rein && rein.parentElement === andere.parentElement) {
    rein.before(andere);
    const stimmen = document.querySelector('main [id$="__vertrauen"]');
    if (stimmen) rein.before(stimmen);
  }

  /* Der Sprungpunkt "#bewertungen" steht am Ende der Geschichte und rechnet damit, dass Judge.me direkt folgt. Auf der Kalenderseite
     liegen die Fragen dazwischen, der Sprung landete bei den Fragen (09.10.2026): deshalb ans Ende der Sektion vor Judge.me. */
  const anker = document.getElementById('bewertungen');
  const judge = anker && Array.from(document.querySelectorAll('.shopify-section')).find((s) => s.id.endsWith('__bewertungen'));
  if (anker && judge && judge.previousElementSibling && judge.previousElementSibling !== anker.closest('.shopify-section')) {
    const ziel = judge.previousElementSibling.querySelector('.zl-d') || judge.previousElementSibling;
    ziel.append(anker);
  }

  /* Labor: das Kleingedruckte am Ende nennt die Pflichtangaben des Kalenders aus dem Kauf, nicht die des Mixpakets */
  const kopie = document.querySelector('[data-zl-d-pflicht-kopie]'), quelle = document.getElementById('zl-b-pflicht');
  if (kopie && quelle) kopie.innerHTML = quelle.innerHTML;

  /* In der Tabelle der Geschichte (wie Produktseite B): je fünf Flaschen jeder Sorte, Zeile "Im Kalender" */
  document.querySelectorAll('[data-zl-g-anzahl]').forEach((td, i, alle) => {
    td.textContent = '5';
    if (i === 0) { const th = td.parentElement && td.parentElement.querySelector('th'); if (th) th.textContent = 'Im Kalender'; }
  });

  root.querySelectorAll('[data-r]').forEach((r) => {
    if (r.hidden) return;
    const k = r.dataset.r;
    messen(k, () => {
      if (k === 'countdown') countdown(r);
      else if (k === 'ausklang') ausklang(r);
      else if (k === 'packzettel') packzettel(r);
      else if (k === 'fuenf' || k === 'brief') { /* still */ }
      else machen(r);
    });
  });

  let laufend = 0;
  const schritt = () => {
    let weiter = false;
    teile.forEach((t) => {
      t.soll = t.ziel();
      const neu = t.ist + (t.soll - t.ist) * 0.2; // token-ok: weiches Aufholen, kein Nachschwingen
      const vorher = t.ist;
      t.ist = Math.abs(t.soll - neu) < 0.0005 ? t.soll : neu;
      if (t.ist !== vorher) t.zeichnen();
      if (t.ist !== t.soll) weiter = true;
    });
    laufend = weiter ? requestAnimationFrame(schritt) : 0;
  };
  window.addEventListener('scroll', () => { if (!laufend) laufend = requestAnimationFrame(schritt); }, { passive: true });
  window.addEventListener('resize', () => { kopfMessen(); teile.forEach((t) => { t.ist = t.soll = t.ziel(); t.zeichnen(); }); }, { passive: true });
  /* Die Reihe zum Wischen erst ganz am Ende: sie braucht reduziert und darf die Szenen darüber nie aufhalten, auch wenn sie stolpert */
  try { messen('karten', karten); } catch (e) { /* ohne Reihe bleibt die Seite benutzbar */ }
  /* Bilder, die die Karten über CSS laden (Beschlag, Masken), kommen erst, wenn die Reihe nah ist (zl-ad-karten.css, ist-nah) */
  { const box = root.querySelector('[data-zl-ad-karten]'); if (box) bald(box, () => box.classList.add('ist-nah')); }
})();

/* Bewertungen auf dem Adventskalender: Der Kalender zeigt die Bewertungen der Biere (Judge.me, Produktgruppe Mixpaket).
   Damit das klar ist, heißt die Überschrift nur hier "Was Kunden über unsere Biere sagen". In Judge.me bleibt sie
   "Kundenbewertungen" für alle Produkte (Moritz, 10.10.2026). Judge.me schreibt das Widget erst nach dem Laden und beim
   Blättern neu, deshalb wird die Überschrift gesetzt, sobald sie da ist, und nach jedem Neuschreiben wieder.
   Die Bewertungen selbst bleiben unberührt. */
(() => {
  if (!document.querySelector('[data-zl-ad]')) return;
  const TITEL = 'Was Kunden über unsere Biere sagen';
  const setzen = () => {
    document.querySelectorAll('.jm-review-widget-minimal-header__title').forEach((el) => {
      if (el.textContent.trim() !== TITEL) el.textContent = TITEL;
    });
  };
  setzen();
  new MutationObserver(setzen).observe(document.body, { childList: true, subtree: true });
})();
